/** 발주서 변환 관련 타입·상수 모음. */

export interface Line {
  품목코드?: string; 품명?: string
  수량?: string | number; 단위?: string; 단가?: string | number
}
export interface SummaryEntry {
  file: string; status: string; date: string; business: string
  line_count: number; lines: Line[]
}
export interface NewPartnerCandidate { name: string }
export interface NewItemCandidate {
  partner_name: string; is_new_partner: boolean
  name: string; unit: string
}
export interface NewPriceCandidate {
  partner_name: string; item_name: string
  sale_price: string; effective_from: string
}
export interface NewOrderLine {
  item_name: string; spec: string; unit: string
  qty: string; unit_price: string
  source_code?: string                 // PO 원본 품목코드
  db_price?: string | null
  db_effective_from?: string | null
  db_price_missing?: boolean
  price_diff?: boolean
  is_new_item?: boolean
  matched_item_id?: number | null
  matched_item_name?: string
}
export interface NewOrderCandidate {
  partner_name: string; is_new_partner: boolean
  partner_id?: number | null
  order_date: string; note?: string; lines: NewOrderLine[]
  missing_price_count?: number
  price_diff_count?: number
  new_item_count?: number
  new_item_names?: string[]
}
export interface UnmatchedDept { dept_code: string; line_count: number }
export interface ConvertResult {
  summary: SummaryEntry[]; download_id: string; total_rows: number
  new_partner_candidates: NewPartnerCandidate[]
  new_item_candidates: NewItemCandidate[]
  new_price_candidates: NewPriceCandidate[]
  new_order_candidates: NewOrderCandidate[]
  items_matched: number
  prices_matched: number
  target_type?: 'partner' | 'group'
  unmatched_depts?: UnmatchedDept[]
}
export type TargetType = 'partner' | 'group'

// 편집 가능 행 (include 토글 포함)
export interface PartnerRow { name: string; include: boolean }
export interface ItemRow {
  partner_name: string; is_new_partner: boolean
  name: string; unit: string; include: boolean
}
export interface PriceRow {
  partner_name: string; item_name: string
  sale_price: string; effective_from: string; include: boolean
}
export interface OrderRow {
  partner_name: string; is_new_partner: boolean
  partner_id?: number | null
  order_date: string; note?: string; lines: NewOrderLine[]; include: boolean
  missing_price_count?: number
  price_diff_count?: number
  new_item_count?: number
  new_item_names?: string[]
}

export interface CommitResult {
  created: { orders: number }
  skipped: { orders: number; lines_no_price: number; lines_no_item: number; duplicates?: number; closed?: number }
  closed_messages?: string[]   // 일일매출 마감된 거래처·월이라 건너뛴 전표 사유
  orders: Array<{ id: number; order_no: string; partner_name: string; lines: number; total: string }>
  manual_needed: {
    items: string[]
    prices: Array<{ partner_name: string; item_name: string; dates: string[] }>
  }
}

export const STATUS_INFO: Record<string, { cls: string; text: string }> = {
  ok:                  { cls: 'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200', text: '변환됨' },
  skipped_image:       { cls: 'bg-amber-100  text-amber-800   ring-1 ring-amber-200',    text: '이미지' },
  skipped_scanned:     { cls: 'bg-amber-100  text-amber-800   ring-1 ring-amber-200',    text: '스캔본' },
  skipped_unsupported: { cls: 'bg-slate-100  text-slate-700   ring-1 ring-slate-200',    text: '미지원' },
  skipped_reference:   { cls: 'bg-slate-100  text-slate-700   ring-1 ring-slate-200',    text: '참조파일' },
  failed:              { cls: 'bg-rose-100   text-rose-800    ring-1 ring-rose-200',     text: '실패' },
}
